import { Autocomplete, AutocompleteChangeReason, FormControl, MenuItem, TextField } from "@mui/material";
import { FieldProps } from "@rjsf/core";
import { useCallback } from "react";
import { useEffect, useState } from "react";
import { LangPropType } from "../SelectCountry";

export const useSelectCountry = (props: FieldProps<string>) => {

    const [value, setValue] = useState<string>(props.formData)
    const [options, setOptions] = useState<Array<LangPropType>>([])
    const [selected, setSelected] = useState<LangPropType>()
    const { title: label } = props.schema

    useEffect(() => {
        const option = findOption(props.formData)
        if (option || props.formData === null) {
            setValue(option?.code || '')
        }
    }, [options, props.formData])

    useEffect(() => {
        setSelected(findOption(value))
    }, [value, options])

    useEffect(() => {
        props.onChange?.(value === '' ? undefined : value)
    }, [value])

    const handleChange = (e: React.SyntheticEvent<Element, Event>, value: LangPropType | null, reason: AutocompleteChangeReason) => {
        setValue(value?.code || '')
    }

    const findOption = useCallback((code?: string) => {
        return options?.find((item) => item.code === code)
    }, [options])

    const getOptionValue = (val: string): LangPropType => {
        try {
            return JSON.parse(val)
        } catch (error) {
            return { name: '', code: '' }
        }
    }

    const renderFlag = (code: string) => (
        <img 
            className="float-left mr-10"
            src={`/assets/img/flag/24x24/${code}.png`} 
            alt={code} />
    )

    const renderCombo = () => (
        <FormControl id={props.idSchema.$id} className={`control-select-language ${props.className}`}>
            <Autocomplete
                options={options}
                autoHighlight
                value={selected || { code: '', name: '' }}
                getOptionLabel={(option) => option.name}
                onChange={handleChange}
                loading={options?.length === 0}
                renderOption={(props, option) => (
                    <MenuItem value={option.code} {...props}>
                        { renderFlag(option.code) } {option.name}
                    </MenuItem>
                )}
                renderInput={(params) => {
                    const option = options?.find((item) => item.name === (params.inputProps as Record<string, unknown>).value as string)
                    return (
                        <div className="control-select-language-selected">
                            { option && renderFlag(option.code) }
                            <TextField
                                {...params}
                                label={label}
                                required={props.required}
                                inputProps={{
                                    ...params.inputProps as any,
                                    autoComplete: 'off',
                                }}
                                />
                        </div>
                    )
                }}
                />
        </FormControl>
    )

    return {
        label,
        handleChange,
        renderCombo,
        options,
        setOptions,
        value,
        setValue,
        getOptionValue,
    }
}
